import React, { useState } from 'react';
import Home from '../Home';
import AllinOne from "../../img/all-in-one-social-media-dashboard-power-bi.png"
import Reputation from "../../img/reputation-management-dashboard.png"

// Reusable SVG Icon Components
const ShieldCheckIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="w-16 h-16 text-white"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 12.75 11.25 15M15 12.75l-2.25 2.25M17.25 6.75h-10.5a1.5 1.5 0 0 0-1.5 1.5v7.5a1.5 1.5 0 0 0 1.5 1.5h10.5a1.5 1.5 0 0 0 1.5-1.5v-7.5a1.5 1.5 0 0 0-1.5-1.5Z"
    />
  </svg>
);

const UserGroupIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="w-16 h-16 text-white"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M18 7.5a.75.75 0 0 1 .75-.75h2.25c.414 0 .75.336.75.75v10.5a.75.75 0 0 1-.75.75h-2.25a.75.75 0 0 1-.75-.75V7.5ZM16.5 7.5a.75.75 0 0 1 .75-.75h2.25c.414 0 .75.336.75.75v10.5a.75.75 0 0 1-.75.75h-2.25a.75.75 0 0 1-.75-.75V7.5Z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 7.5a.75.75 0 0 1 .75-.75h2.25c.414 0 .75.336.75.75v10.5a.75.75 0 0 1-.75.75h-2.25a.75.75 0 0 1-.75-.75V7.5Z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 7.5a.75.75 0 0 1 .75-.75h2.25c.414 0 .75.336.75.75v10.5a.75.75 0 0 1-.75.75h-2.25a.75.75 0 0 1-.75-.75V7.5Z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4.5 7.5a.75.75 0 0 1 .75-.75h2.25c.414 0 .75.336.75.75v10.5a.75.75 0 0 1-.75.75h-2.25a.75.75 0 0 1-.75-.75V7.5Z"
    />
  </svg>
);

const ChartBarIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="w-16 h-16 text-white"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 13.5a9 9 0 0 1 18 0"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 10.5a9 9 0 0 1 18 0"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 7.5a9 9 0 0 1 18 0"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 4.5a9 9 0 0 1 18 0"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 16.5a9 9 0 0 1 18 0"
    />
  </svg>
);


// Accordion component for FAQ
const Accordion = ({ title, content }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-b border-gray-200">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex justify-between items-center w-full py-4 text-left font-semibold text-lg text-gray-800 hover:text-indigo-600 transition-colors"
      >
        <span>{title}</span>
        <span className={`transform transition-transform duration-300 ${isOpen ? 'rotate-180' : 'rotate-0'}`}>
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </span>
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 py-2' : 'max-h-0 opacity-0'}`}
      >
        <p className="text-gray-600 leading-relaxed">{content}</p>
      </div>
    </div>
  );
};

function SocialMediaManagemant() {
  return (
    <Home>
    <div className="min-h-screen bg-gray-50 font-sans text-gray-800 antialiased">
      {/* Tailwind CSS is assumed to be available. */}
      <script src="https://cdn.tailwindcss.com"></script>
      <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap" />
      <style>{`body { font-family: 'Inter', sans-serif; }`}</style>

      {/* Hero Section */}
      <header className="relative bg-gradient-to-br from-indigo-600 to-indigo-800 text-white py-24 px-4 sm:px-6 lg:px-8 overflow-hidden">
        <div className="absolute inset-0 bg-white opacity-10 blur-3xl transform scale-150 rounded-full"></div>
        <div className="relative z-10 max-w-7xl mx-auto text-center">
          <h1 className="text-4xl sm:text-6xl lg:text-7xl font-bold tracking-tight mb-4 leading-tight">
            Your Clinic's Reputation, <br className="hidden sm:inline" />Our Expertise
          </h1>
          <p className="text-lg sm:text-xl lg:text-2xl font-light mb-8 max-w-4xl mx-auto opacity-90">
            A sterling online reputation isn't just a goal—it's the cornerstone of your clinic's growth. We craft a digital presence that builds trust and attracts patients.
          </p>
          <button className="bg-white text-indigo-700 font-semibold px-10 py-4 rounded-full shadow-xl hover:bg-gray-100 transition-transform transform hover:scale-105 hover:shadow-2xl">
            Request a Free Analysis
          </button>
        </div>
      </header>

      {/* Trust & Authority Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white relative -mt-16 z-20">
        <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-8 text-center">
          <div className="flex flex-col items-center p-8 bg-white rounded-2xl shadow-xl border border-gray-100 transform transition-transform hover:scale-105 hover:shadow-2xl">
            <div className="w-20 h-20 bg-indigo-500 rounded-full flex items-center justify-center mb-6 shadow-md">
              <ShieldCheckIcon />
            </div>
            <h3 className="text-2xl font-bold mb-2">Build Trust</h3>
            <p className="text-gray-600">
              Proactively cultivate a positive online image and respond professionally to all patient feedback.
            </p>
          </div>
          <div className="flex flex-col items-center p-8 bg-white rounded-2xl shadow-xl border border-gray-100 transform transition-transform hover:scale-105 hover:shadow-2xl">
            <div className="w-20 h-20 bg-emerald-500 rounded-full flex items-center justify-center mb-6 shadow-md">
              <UserGroupIcon />
            </div>
            <h3 className="text-2xl font-bold mb-2">Engage Patients</h3>
            <p className="text-gray-600">
              Create a dynamic social presence that nurtures relationships and fosters a loyal patient community.
            </p>
          </div>
          <div className="flex flex-col items-center p-8 bg-white rounded-2xl shadow-xl border border-gray-100 transform transition-transform hover:scale-105 hover:shadow-2xl">
            <div className="w-20 h-20 bg-pink-500 rounded-full flex items-center justify-center mb-6 shadow-md">
              <ChartBarIcon />
            </div>
            <h3 className="text-2xl font-bold mb-2">Drive Growth</h3>
            <p className="text-gray-600">
              Transform positive reviews into powerful marketing assets that attract new patients and increase revenue.
            </p>
          </div>
        </div>
      </section>

      {/* Asymmetrical Showcase Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">
          <div className="relative rounded-3xl overflow-hidden shadow-2xl">
            <img
              src={AllinOne}
              alt="Unified Social Media Dashboard"
              className="w-full h-auto object-cover transform scale-105 transition-transform duration-500 hover:scale-100"
            />
          </div>
          <div className="lg:pr-12">
            <span className="text-sm font-semibold text-indigo-600 uppercase tracking-wider mb-2 block">Our Approach</span>
            <h2 className="text-4xl font-bold mb-6 leading-tight">
              A Unified Dashboard for Complete Control
            </h2>
            <p className="text-lg text-gray-600 mb-6">
              Our intuitive platform consolidates all your social media channels and review sites into a single, elegant view. Monitor conversations, track your reputation score, and get instant alerts—all from one place.
            </p>
            <ul className="space-y-4 text-lg">
              <li className="flex items-center">
                <span className="text-indigo-600 mr-2">✓</span> Real-time Review Monitoring
              </li>
              <li className="flex items-center">
                <span className="text-indigo-600 mr-2">✓</span> Automated Review Requests
              </li>
              <li className="flex items-center">
                <span className="text-indigo-600 mr-2">✓</span> Insightful Performance Analytics
              </li>
              <li className="flex items-center">
                <span className="text-indigo-600 mr-2">✓</span> AI-Powered Content Suggestions
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Callout Section with Image */}
      <section className="bg-gray-100 py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">Protecting What Matters Most</h2>
          <p className="text-lg text-gray-600 mb-12 max-w-2xl mx-auto">
            Your reputation is priceless. We help you guard against negative feedback and build an authentic, trustworthy brand.
          </p>
          <div className="relative max-w-4xl mx-auto">
            <div className="rounded-3xl shadow-2xl overflow-hidden">
              <img
                src={Reputation}
                alt="Reputation Crisis Management"
                className="w-full h-auto object-cover transform scale-105 transition-transform duration-500 hover:scale-100"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section - Card Deck */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">Transparent Pricing, Powerful Results</h2>
          <p className="text-lg text-gray-600 mb-12">
            We offer plans designed to scale with your clinic, from essential monitoring to comprehensive management.
          </p>
          <div className="grid lg:grid-cols-3 gap-8 items-stretch">
            {/* Essential Plan */}
            <div className="flex flex-col rounded-3xl shadow-xl border border-gray-200 p-8 transform transition-transform hover:scale-105 hover:shadow-2xl">
              <h3 className="text-2xl font-bold text-indigo-600 mb-2">Essential</h3>
              <p className="text-gray-500 mb-4">Start your journey to a better reputation.</p>
              <div className="my-6">
                <span className="text-5xl font-extrabold text-gray-900">₹6200</span>
                <span className="text-xl font-medium text-gray-500">/mo</span>
              </div>
              <ul className="text-left space-y-3 text-gray-700 flex-grow">
                <li><span className="text-indigo-600 mr-2">✓</span> Single Platform Monitoring</li>
                <li><span className="text-indigo-600 mr-2">✓</span> Basic Review Response Templates</li>
                <li><span className="text-indigo-600 mr-2">✓</span> Monthly Reports</li>
                <li className="text-gray-400">✗ Automated Review Campaigns</li>
                <li className="text-gray-400">✗ Social Media Content Creation</li>
              </ul>
              <div className="mt-8">
                <button className="w-full bg-indigo-600 text-white font-semibold py-4 rounded-full shadow-md hover:bg-indigo-700 transition-colors">
                  Choose Essential
                </button>
              </div>
            </div>

            {/* Premium Plan */}
            <div className="flex flex-col rounded-3xl shadow-xl border-4 border-indigo-600 bg-white p-8 transform transition-transform hover:scale-105 hover:shadow-2xl z-10">
              <h3 className="text-2xl font-bold text-indigo-600 mb-2">Premium</h3>
              <p className="text-gray-500 mb-4">Accelerate your growth with comprehensive management.</p>
              <div className="my-6">
                <span className="text-5xl font-extrabold text-gray-900">₹9099</span>
                <span className="text-xl font-medium text-gray-500">/mo</span>
              </div>
              <ul className="text-left space-y-3 text-gray-700 flex-grow">
                <li><span className="text-indigo-600 mr-2">✓</span> All Essential features</li>
                <li><span className="text-indigo-600 mr-2">✓</span> Multi-Platform Management</li>
                <li><span className="text-indigo-600 mr-2">✓</span> Automated Review Campaigns</li>
                <li><span className="text-indigo-600 mr-2">✓</span> Custom Social Content (3 posts/week)</li>
                <li><span className="text-indigo-600 mr-2">✓</span> Priority Support</li>
              </ul>
              <div className="mt-8">
                <button className="w-full bg-indigo-600 text-white font-semibold py-4 rounded-full shadow-md hover:bg-indigo-700 transition-colors">
                  Choose Premium
                </button>
              </div>
            </div>

            {/* Enterprise Plan */}
            <div className="flex flex-col rounded-3xl shadow-xl border border-gray-200 p-8 transform transition-transform hover:scale-105 hover:shadow-2xl">
              <h3 className="text-2xl font-bold text-indigo-600 mb-2">Enterprise</h3>
              <p className="text-gray-500 mb-4">For large clinics with multiple locations.</p>
              <div className="my-6">
                <span className="text-5xl font-extrabold text-gray-900">Custom</span>
              </div>
              <ul className="text-left space-y-3 text-gray-700 flex-grow">
                <li><span className="text-indigo-600 mr-2">✓</span> All Premium features</li>
                <li><span className="text-indigo-600 mr-2">✓</span> Dedicated Account Manager</li>
                <li><span className="text-indigo-600 mr-2">✓</span> Local SEO & GMB Optimization</li>
                <li><span className="text-indigo-600 mr-2">✓</span> Crisis Management & PR Strategy</li>
                <li><span className="text-indigo-600 mr-2">✓</span> Advanced Analytics & Reporting</li>
              </ul>
              <div className="mt-8">
                <button className="w-full bg-indigo-600 text-white font-semibold py-4 rounded-full shadow-md hover:bg-indigo-700 transition-colors">
                  Contact Us
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section with Accordion */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold text-center mb-12">
            Answers to Your Questions
          </h2>
          <div className="space-y-4">
            <Accordion
              title="How do you handle negative reviews?"
              content="We respond to all reviews with a professional and empathetic tone, publicly acknowledging the feedback and offering to move the conversation offline. Our goal is to demonstrate your commitment to patient satisfaction and resolve issues privately."
            />
            <Accordion
              title="Can you guarantee a specific star rating?"
              content="While we can't guarantee a specific star rating, our strategies are proven to improve your overall rating by generating a higher volume of positive reviews and effectively mitigating the impact of negative feedback."
            />
            <Accordion
              title="What social media platforms do you manage?"
              content="We provide full management for major platforms including Google Business Profile, Facebook, Instagram, LinkedIn, and Twitter, customizing content to resonate with each platform's unique audience."
            />
            <Accordion
              title="How long does it take to see results?"
              content="Many clients see improvements in review volume and engagement within the first 30 days. Significant improvements in star rating and search engine visibility typically become more apparent over a 3-6 month period."
            />
          </div>
        </div>
      </section>

      {/* Final Call to Action Section */}
      <section className="bg-indigo-600 text-white py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">Ready to Transform Your Reputation?</h2>
          <p className="text-lg sm:text-xl font-light mb-8">
            Let's work together to build a digital presence that reflects the quality of your care.
          </p>
          <button className="bg-white text-indigo-700 font-semibold px-10 py-4 rounded-full shadow-lg hover:bg-gray-100 transition-transform transform hover:scale-105">
            Get Started Today
          </button>
        </div>
      </section>

    </div>
    </Home>
  );
}

export default SocialMediaManagemant;


